import { useEffect } from "react";

function App() {
  useEffect(() => {
    window.location.replace("/leviom.html");
  }, []);
  return null;
}

export default App;
